import { render, staticRenderFns } from "./configuration-assays-groups-modal-basic-form.vue?vue&type=template&id=478631c8&scoped=true&"
import script from "./configuration-assays-groups-modal-basic-form.ts?vue&type=script&lang=ts&"
export * from "./configuration-assays-groups-modal-basic-form.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-assays-groups-modal-basic-form.scss?vue&type=style&index=0&id=478631c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478631c8",
  null
  
)

export default component.exports